import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import YourComprehensiveTransportationSolutions from "./sections/YourComprehensiveTransportationSolutions";
import OurTransportationServices from "./sections/OurTransportationServices";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <YourComprehensiveTransportationSolutions />
      <OurTransportationServices />
      <Footer />
    </div>;
}